/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import {
  border,
  color,
  layout,
  space,
  padding,
  MarginProps,
  PaddingProps,
  ColorProps,
  LayoutProps,
  BorderProps,
} from 'styled-system';
import { StyledComponent } from '@emotion/styled';
import styled from './styled';

type Props = {
  borderStyle?: string;
  borderColor?: string;
  borderWidth?: number;
  borderRadius?: number;
  color?: string;
  hoverBorderColor?: string;
  disabled?: boolean;
};

type StyledProps = MarginProps &
  PaddingProps &
  ColorProps &
  LayoutProps &
  BorderProps;

const TextInput: StyledComponent<
  Props &
    StyledProps &
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >
> = styled.input<Props>(
  (props) => ({
    height: '3.125rem',
    padding: 0,
    zIndex: 1,
    fontFamily: '"Source Sans Pro", sans-serif',
    fontSize: '1rem',
    backgroundColor: 'transparent',
    color: props.disabled ? '#dadada' : props.color,
    outline: 'none',
    '&:hover:not(:focus)': {
      borderColor: props.hoverBorderColor,
      cursor: 'pointer',
    },
    '&::placeholder': {
      color: '#a3b2bf',
      opacity: 1,
    },
  }),
  space,
  padding,
  color,
  layout,
  border,
);

TextInput.defaultProps = {
  borderStyle: 'solid',
  borderColor: 'separator',
  borderWidth: 2,
  borderRadius: 4,
  color: 'text',
  hoverBorderColor: '#a3b2bf',
};

export default TextInput;
